import React from "react";
import styled from "styled-components";

import { DashboardRouter } from "./DashboardRouter";
import { DashboardTabNavigation } from "./TabNavigation";

export const BusinessDashboard = () => {
  return (
    <Container>
      <DashboardTabNavigation />
      <DashboardRouter />
    </Container>
  );
};

const Container = styled.section`
  width: 100%;
`;
